import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const searchAnime = (q) => api.get(`/anime/search`, { params: { q, creator_id: getCreatorId() } }).then(r => r.data);
export const addAnime = (payload) => api.post(`/anime`, { ...payload, creator_id: getCreatorId() }).then(r => r.data);
export const listAnime = (params = {}) => api.get(`/anime`, { params: { ...params, creator_id: getCreatorId() } }).then(r => r.data);
export const getAnime = (mal_id) => api.get(`/anime/${mal_id}`, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const updateAnime = (mal_id, payload) => api.patch(`/anime/${mal_id}`, { ...payload, creator_id: getCreatorId() }).then(r => r.data);
export const deleteAnime = (mal_id) => api.delete(`/anime/${mal_id}`, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const getStats = () => api.get(`/stats`, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const getStudioStats = () => api.get(`/stats/studios`, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const getDirectorStats = () => api.get(`/stats/directors`, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const getBadges = () => api.get(`/badges`, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const checkBadges = () => api.post(`/badges/check`, null, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const getRecommendations = () => api.get(`/recommendations`, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const getPersonality = () => api.get(`/personality`, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const getWrapped = (year) => api.get(`/wrapped/${year}`, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const getTimeline = () => api.get(`/timeline`, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const generateBlurb = (payload) => api.post(`/blurb`, payload).then(r => r.data);
export const importAnilist = (username, limit = 50) => api.post(`/import/anilist`, { username, limit, creator_id: getCreatorId() }).then(r => r.data);
export const importMal = (username, limit = 50) => api.post(`/import/mal`, { username, limit, creator_id: getCreatorId() }).then(r => r.data);
export const sharePersona = (creator_id) => api.post(`/persona/share`, { creator_id }).then(r => r.data);
export const getSharedPersona = (share_id) => api.get(`/persona/shared/${share_id}`).then(r => r.data);
export const getPersonaHistory = (creator_id) => api.get(`/persona/history`, { params: { creator_id } }).then(r => r.data);
export const getDiscover = (creator_id) => api.get(`/discover`, { params: { creator_id } }).then(r => r.data);
export const getStreaks = () => api.get(`/streaks`, { params: { creator_id: getCreatorId() } }).then(r => r.data);
export const aiSearch = (query) => api.post(`/search/ai`, { query, creator_id: getCreatorId() }).then(r => r.data);
export const getSchedule = (day = "all") => api.get(`/schedule`, { params: { day, creator_id: getCreatorId() } }).then(r => r.data);
export const trackFromSchedule = (mal_id, status = "watching") => api.post(`/schedule/track`, { mal_id, status, creator_id: getCreatorId() }).then(r => r.data);

// Payments
export const getPaymentsCatalog = () => api.get(`/payments/catalog`).then(r => r.data);
export const createCheckout = (lookup_key, creator_id) =>
  api.post(`/payments/checkout`, { lookup_key, origin_url: window.location.origin, creator_id }).then(r => r.data);
export const getPaymentStatus = (session_id) => api.get(`/payments/status/${session_id}`).then(r => r.data);
export const getUnlocks = (creator_id) => api.get(`/unlocks`, { params: { creator_id } }).then(r => r.data);
export const getSubscription = (creator_id) => api.get(`/subscription/status`, { params: { creator_id } }).then(r => r.data);
export const openBillingPortal = () =>
  api.post(`/subscription/portal`, { return_url: `${window.location.origin}/account`, creator_id: getCreatorId() }).then(r => r.data);
export const cancelSubscription = ({ reason, comment } = {}) =>
  api.post(`/subscription/cancel`, { creator_id: getCreatorId(), reason, comment }).then(r => r.data);
export const acceptSaveOffer = () =>
  api.post(`/subscription/accept_save_offer`, { creator_id: getCreatorId() }).then(r => r.data);
export const saveOfferShown = () =>
  api.post(`/subscription/save_offer/shown`, { creator_id: getCreatorId() }).then(r => r.data).catch(() => null);
export const getAdminCancellations = () => api.get(`/admin/cancellations`).then(r => r.data);
export const getAdminBusiness = (days = 30) => api.get(`/admin/business`, { params: { days } }).then(r => r.data);
export const switchToYearly = () =>
  api.post(`/subscription/switch_to_yearly`, { creator_id: getCreatorId() }).then(r => r.data);

// Feature Request Board
export const listFeatures = () => api.get(`/features`).then(r => r.data);
export const voteFeature = (id) => api.post(`/features/${id}/vote`).then(r => r.data);
export const createFeature = (payload) => api.post(`/features`, payload).then(r => r.data);
export const updateFeature = (id, payload) => api.patch(`/features/${id}`, payload).then(r => r.data);
export const deleteFeature = (id) => api.delete(`/features/${id}`).then(r => r.data);

// Auth
export const exchangeAuthSession = (session_id, guest_creator_id) =>
  api.post(`/auth/session`, { session_id, guest_creator_id }).then(r => r.data);
export const getMe = () => api.get(`/auth/me`).then(r => r.data);
export const logout = () => api.post(`/auth/logout`).then(r => r.data);
export const setHandle = (handle) => api.post(`/auth/handle`, { handle }).then(r => r.data);
export const setProfilePublic = (profile_public) => api.post(`/auth/profile_public`, { profile_public }).then(r => r.data);
export const getPublicProfile = (handle) => api.get(`/u/${handle}`).then(r => r.data);
export const getAccountSummary = () => api.get(`/account/summary`).then(r => r.data);
export const getAccountExport = () => api.get(`/account/export`).then(r => r.data);

// Follows & Feed
export const followUser = (handle) => api.post(`/follow/${handle}`).then(r => r.data);
export const unfollowUser = (handle) => api.delete(`/follow/${handle}`).then(r => r.data);
export const getFollowStatus = (handle) => api.get(`/follow/status/${handle}`).then(r => r.data);
export const getFollowList = () => api.get(`/follow/list`).then(r => r.data);
export const getFeed = (limit = 40) => api.get(`/feed`, { params: { limit } }).then(r => r.data);
// Compare Personas
export const compareProfiles = (handleA, handleB) =>
  api.get(`/compare/${handleA}/${handleB}`).then(r => r.data);

// Local creator identity (no auth) — persisted in localStorage so history/discover work per-browser.
// NOTE: creator_id is a random pseudonym, NOT an authentication token. Auth tokens are httpOnly cookies.
export function getCreatorId() {
  const KEY = "otaku_creator_id";
  let id = null;
  try {
    id = window.localStorage.getItem(KEY);
  } catch (err) {
    console.warn("localStorage read failed:", err);
  }
  if (!id) {
    id = "cr_" + Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 8);
    try {
      window.localStorage.setItem(KEY, id);
    } catch (err) {
      console.warn("localStorage write failed:", err);
    }
  }
  return id;
}

export const STATUS_LABELS = {
  completed: "Completed",
  watching: "Watching",
  plan_to_watch: "Plan to Watch",
  dropped: "Dropped",
  on_hold: "On Hold",
};

export const STATUS_COLORS = {
  completed: "text-emerald-400 border-emerald-500/40",
  watching: "text-[#FF3B30] border-[#FF3B30]/50",
  plan_to_watch: "text-sky-400 border-sky-500/40",
  dropped: "text-neutral-500 border-neutral-700",
  on_hold: "text-amber-400 border-amber-500/40",
};
